import { render, staticRenderFns } from "./editApp.vue?vue&type=template&id=0f272620&scoped=true"
import script from "./editApp.vue?vue&type=script&lang=js"
export * from "./editApp.vue?vue&type=script&lang=js"
import style0 from "./editApp.vue?vue&type=style&index=0&id=0f272620&prod&lang=scss&scoped=true"
import style1 from "./editApp.vue?vue&type=style&index=1&id=0f272620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f272620",
  null
  
)

export default component.exports